import { wsService } from "../wsService";

const section = "wallet";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function getBalance(param = {}) {
  return wsService.make_post_request(section + "/balance", param);
}

function get(param = {}) {
  return wsService.make_post_request(section + "/get", param);
}

export const walletService = {
  section,
  filter,
  getBalance,
  get,
};
